// Must be first: captures window.location.search before TanStack Router mounts
// and strips OAuth params (used by the MCP sign-in hand-back). Imported for the
// side effect of evaluating the module-level capture at boot.
import "./lib/bootSearch";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { routeTree } from "./routeTree.gen";
import { queryClient } from "./lib/queryClient";
import { applyTheme, applyAppearance } from "./lib/theme";
import { BrandingProvider } from "./lib/branding";
import { CapabilitiesProvider } from "./lib/capabilities";
import { ErrorBoundary } from "./components/ErrorBoundary";

applyTheme();
applyAppearance();
matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () =>
  applyTheme(),
);

const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const root = document.getElementById("root");
if (!root) throw new Error("#root missing");
createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrandingProvider>
          <CapabilitiesProvider>
            <RouterProvider router={router} />
          </CapabilitiesProvider>
        </BrandingProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
